module.exports = __webpack_public_path__ + "img/participant-picture-1.5a89aa5.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/participant-picture-1.svg
// module id = HIMx
// module chunks = 0